
document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.facet-wrapper');
  if (!wrapper) return;

  const header = document.querySelector('.shopify-section-header, header');
  const getHeaderHeight = () => header ? header.offsetHeight : 0;

  const placeholder = document.createElement('div');
  placeholder.className = 'facet-wrapper-placeholder';
  wrapper.parentNode.insertBefore(placeholder, wrapper);

  let startOffset = 0;
  let height = 0;

  function recalc() {
    const headerHeight = getHeaderHeight();
    startOffset = wrapper.getBoundingClientRect().top + window.scrollY - headerHeight;
    height = wrapper.offsetHeight;
  }

  function onScroll() {
    const headerHeight = getHeaderHeight();

    if (window.scrollY >= startOffset) {
      wrapper.classList.add('is-stuck');
      wrapper.style.top = headerHeight + 'px';
      placeholder.style.height = height + 'px';
    } else {
      wrapper.classList.remove('is-stuck');
      wrapper.style.top = '';
      placeholder.style.height = '0px';
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', recalc);

  // Initial + after dynamic content loads
  recalc();
  setTimeout(recalc, 300);
  setTimeout(recalc, 800);
}); 
